import axios from 'axios'
import lang from '@data/lang.json'

const StorePicker = {
  // Props
  props: ['getEndpoint', 'setEndpoint'],
  // Data
  data() {
    return {
      isToggled: false,
      lang: lang.StorePicker,
      selectedItem: null,
      selectedText: lang.StorePicker.DefaultText
        ? lang.StorePicker.DefaultText
        : 'Välj butik',
      status: 'idle',
      stores: [],
    }
  },
  // Methods
  methods: {
    onStoreSelect: function (store) {
      axios
        .post(this.setEndpoint, {
          Id: store.Id,
        })
        .then(function (response) {
          const data = !!response && response?.data ? response.data : null

          const newUrl =
            data.Data != null || data.Data != ''
              ? data.Data
              : window.location.href

          window.location.href = newUrl
        })
        .catch(function (error) {
          // console.log('STORE SELECT ERROR:', error)
        })
    },
    setSelectedItem: function (items) {
      const activeItem = items.filter(item => {
        return item.Selected === true ? item : null
      })
      this.selectedItem = activeItem.length > 0 ? activeItem[0].Id : null
      this.selectedText = this.setSelectedText(
        activeItem.length > 0 ? activeItem[0].Name : null
      )
    },
    storePickerToggle: function () {
      this.isToggled = !this.isToggled
      document
        .querySelector('html')
        .classList.toggle('store-picker--active', this.isToggled)
    },
    setSelectedText: function (selectedItem) {
      const selectedText = lang.SelectedText ? lang.SelectedText : 'Vald butik'
      const defaultText = lang.DefaultText ? lang.DefaultText : 'Välj butik'

      return selectedItem != null
        ? `${selectedText}: ${selectedItem}`
        : defaultText
    },
  },
  // Life cycle
  mounted() {
    this.status = 'loading'
    axios
      .get(this.getEndpoint)
      .then(response => {
        let data = response?.data?.Data
        data = !!data ? data : []
        this.stores = data
        this.setSelectedItem(data)
        this.status = 'success'
      })
      .catch(error => {
        this.status = 'error'
        // console.log('STORE PICKER ERROR', error)
      })
  },
}

export default StorePicker
